<section>
  <div class="tool-description">
    The navigate support page gives you a guide on how to navigate throughout
    the dashboard. Such as navigating to each tool and to the help page. Below
    are some links to each individual section in this page for the navigation
    guide such as Success Metrics, Admin Support, Admin Support External and
    Help Page.
  </div>

  <div class="buttons-nav">
    <div class="example-button-row">
      <a (click)="scroll(homepage)"> Home Page Nav Guide </a>
      <span> &nbsp; | &nbsp; </span>
      <a (click)="scroll(successmetrics)"> Success Metrics Nav Guide </a>
      <span> &nbsp; | &nbsp; </span>
      <a (click)="scroll(adminsupport)"> Admin Support Card Nav Guide </a>
      <span> &nbsp; | &nbsp; </span>
      <a (click)="scroll(adminsupportexternal)">
        Admin Support External Nav Card Guide
      </a>
      <span> &nbsp; | &nbsp; </span>
      <a (click)="scroll(helppage)"> Help Page Nav Guide </a>
    </div>
  </div>

  <!-------------------- Homepage Navigate Content -------------------->
  <div #homepage class="indv-page-div">
    <h2 class="indv-page-h2">Home Page (3 sections)</h2>

    <div>
      <img [(src)]="env['logo_paths']['navSupportFigure1']" alt="" />
      <p>Figure 1: Homepage</p>
    </div>

    <h3 class="indv-page-h3">Navigating the Home Page</h3>
    <ul class="indv-page-ul">
      <li>
        In the home page, as you scroll down the page. There are three different
        sections (Success Metrics, Admin Support, Admin Support External) for
        different uses.
      </li>
      <li>
        Each section contains individual tools related to the section. For
        example, the Success Metrics section (Figure 2) contains seven tools
        such as Student Profile, Cohort Profile, Advisor Identified At-Risk,
        Course Combinations, Prerequisite Impact, Program Bottleneck Courses,
        Course Recommender, Course Grade Estimation.
      </li>
    </ul>
  </div>

  <mat-divider></mat-divider>

  <!-------------------- Success Metrics Content -------------------->
  <div #successmetrics class="indv-page-div">
    <h2 class="indv-page-h2">Success Metrics</h2>
    <ul class="indv-page-ul">
      <li>
        The Success Metrics section contains individual tools related to the
        section such as Student Profile, Cohort Profile, Advisor Identified
        At-Risk, Course Combinations, Prerequisite Impact, Program Bottleneck
        Courses, Course Recommender, Course Grade Estimation. (Figure 2)
      </li>
    </ul>

    <div>
      <img [(src)]="env['logo_paths']['navSupportFigure2']" alt="" />
      <p>Figure 2: Success Metrics section</p>
    </div>
    <h3 class="indv-page-h3">Navigating the Success Metrics Tools</h3>
    <h3 class="indv-page-h3">
      <i>Success Metrics Section (8 Tools)</i>
    </h3>
    <ul class="indv-page-ul">
      <li>
        Click into one of the cards (Student Profile, Cohort Profile, Advisor
        Identified At-Risk, Course Combinations,Prerequisite Impact, Program
        Bottleneck Courses, Course Recommender, Course Grade Estimation) to
        utilize the tool and you will be directed into the tool's page.
      </li>
    </ul>
  </div>

  <mat-divider></mat-divider>

  <!-------------------- Admin Support Navigate Content -------------------->
  <div #adminsupport class="indv-page-div">
    <h2 class="indv-page-h2">Admin Support</h2>
    <ul class="indv-page-ul">
      <li>
        The Admin Support section contains individual tools related to the
        section such as APR/Graduation/Summary, Entry or Exit Flow Graph, FTIC
        Course DWF & APR. (Figure 3)
      </li>
    </ul>

    <div>
      <div>
        <img [(src)]="env['logo_paths']['navSupportFigure3']" alt="" />
        <p>Figure 3: Admin Support</p>
      </div>

      <h3 class="indv-page-h3">Navigating the Admin Support Tools</h3>
      <h3 class="indv-page-h3">
        <i>Admin Support Section (3 Tools)</i>
      </h3>
      <ul class="indv-page-ul">
        <li>
          Click into one of the cards (APR/Graduation/Summary, Entry or Exit
          Flow Graph, FTIC Course DWF & APR) to utilize the tool and you will be
          directed into the tool's page.
        </li>
      </ul>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-------------------- Admin Support External Navigate Content -------------------->
  <div #adminsupportexternal class="indv-page-div">
    <h2 class="indv-page-h2">Admin Support External</h2>
    <ul class="indv-page-ul">
      <li>
        The Admin Support External section contains individual tools related to
        the section such as APR/Graduation/Summary, Entry or Exit Flow Graph,
        FTIC Course DWF & APR, New Applicants, Three-Year Graduation Rate,
        Transfer Enrollment and Trends, Critical Course Score. (Figure 4)
      </li>
    </ul>

    <div>
      <div>
        <img [(src)]="env['logo_paths']['navSupportFigure4']" alt="" />
        <p>Figure 4: Admin Support External</p>
      </div>

      <h3 class="indv-page-h3">Navigating the Admin Support External Tools</h3>
      <h3 class="indv-page-h3">
        <i>Admin Support External Section (7 Tools)</i>
      </h3>
      <ul class="indv-page-ul">
        <li>
          Click into one of the cards (APR/Graduation/Summary, Entry or Exit
          Flow Graph, FTIC Course DWF & APR, New Applicants, Three-Year
          Graduation Rate, Transfer Enrollment and Trends, Critical Course
          Score) to utilize the tool and you will be directed into the external
          tool's page.
        </li>
      </ul>
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-------------------- Help Page Navigate Content -------------------->
  <div #helppage class="indv-page-div">
    <h2 class="indv-page-h2">Help Page</h2>
    <div>
      <img [(src)]="env['logo_paths']['navSupportFigure5']" alt="" />
      <p>Figure 5: Navbar in Homepage</p>
    </div>

    <ul class="indv-page-ul">
      <li>
        In the home page you can navigate to the help page by clicking on the
        'Help' on the navbar at the top of the page. (Figure 5)
      </li>
    </ul>

    <div>
      <div>
        <img [(src)]="env['logo_paths']['navSupportFigure6']" alt="" />
        <p>Figure 6: Help Page</p>
      </div>

      <h3 class="indv-page-h3">Navigating the Help Page</h3>
      <h3 class="indv-page-h3">
        <i>Help Page (3 Cards)</i>
      </h3>
      <ul class="indv-page-ul">
        <li>
          Click into one of the cards (Using the Tools, Navigation Support,
          Glossary of Terms) to view more information about using the tools,
          navigating the dashboard, and getting definition of terms throughout
          the dashboard.
        </li>
      </ul>
    </div>
  </div>
</section>
